// src/Home.js
import React, { useState, useEffect,  } from 'react';
import AnimateOnScroll from './../../components/common/animate';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { toast } from 'react-toastify';
export default function Pricing() {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState({});

    const getServices = () => {
      setLoading(true);
      DataService.getServicesData()
        .then((response) => {
          setCategories(response.data); // expects object: { Facial: [{id, name, price}, ...], Waxing: [...] }
        })
        .catch((error) => {
          console.error('Failed to fetch services:', error);
        })
        .finally(() => setLoading(false));
    };
  
    useEffect(() => {
      getServices();
    }, []);
 const renderCategoryBlock = (categoryName, services, index) => (
    <AnimateOnScroll key={categoryName} className={`col-md-4 col-eq ${index % 3 === 0 ? 'ftco-animated fadeInUp gradient' : ''}`}>
      <div className={`block-7 `}>
        <div className="text-left">
          <div className="pricing-hd-block">
            <div className="pricing-block">
              <h3 className={`heading ${index % 3 === 0 ? 'hd-white' : ''}`}>{categoryName}</h3>
              <div className="elementor-widget-cmsmasters-featured-box__icon-wrap elementor-widget-cmsmasters-featured-box__graphic-item">
                <i aria-hidden="true" className="cmsmsdemo-icons- cmsms-demo-icons-wellness-bliss" />
              </div>
            </div>
          </div>
          <ul className="pricing-text mb-5">
            {services.map((item) => (
              <li key={item.id || item.name} className="icon-list-item">
                <span className="icon-list-item-text-wrap">
                  <span className="icon-list-item-text">{item.name}</span>
                  <span className="cmsmasters-widget-icon-list-item-value">${item.price}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </AnimateOnScroll>
  );

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div>
        <Helmet>
          {/* Primary Meta Tags */}
          <title>Pricing - Beauty Services | Divine Blush Beauty Regina SK</title>
          <meta name="title" content="Pricing - Beauty Services | Divine Blush Beauty Regina SK" />
          <meta
            name="description"
            content="Explore Divine Blush Beauty's affordable pricing for personalized beauty treatments in Regina, SK. Transparent pricing for facials, waxing, makeup, hair services, and more. Quality service at competitive rates."
          />
          <meta name="keywords" content="beauty salon prices Regina, facial pricing Regina SK, waxing prices Regina, makeup prices Regina, hair services cost Regina, affordable beauty treatments Regina, Divine Blush Beauty pricing" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://www.divineblushbeauty.ca/pricing" />
          <link rel="icon" href="/favicon.ico" type="image/x-icon" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.divineblushbeauty.ca/pricing" />
          <meta property="og:title" content="Pricing - Beauty Services | Divine Blush Beauty Regina SK" />
          <meta property="og:description" content="Explore Divine Blush Beauty's affordable pricing for personalized beauty treatments in Regina, SK. Transparent pricing for facials, waxing, makeup, and hair services." />
          <meta property="og:image" content="https://www.divineblushbeauty.ca/images/pricing_banner.jpg" />
          <meta property="og:site_name" content="Divine Blush Beauty" />
          <meta property="og:locale" content="en_CA" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content="https://www.divineblushbeauty.ca/pricing" />
          <meta name="twitter:title" content="Pricing - Beauty Services | Divine Blush Beauty Regina SK" />
          <meta name="twitter:description" content="Explore Divine Blush Beauty's affordable pricing for personalized beauty treatments in Regina, SK." />
          <meta name="twitter:image" content="https://www.divineblushbeauty.ca/images/pricing_banner.jpg" />

          {/* Structured Data - Price List */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "PriceSpecification",
                "name": "Divine Blush Beauty Services Pricing",
                "description": "Comprehensive pricing list for beauty services at Divine Blush Beauty in Regina, SK",
                "priceCurrency": "CAD",
                "provider": {
                  "@type": "BeautySalon",
                  "name": "Divine Blush Beauty",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "3104, Crossbie Cres",
                    "addressLocality": "Regina",
                    "addressRegion": "SK",
                    "postalCode": "S4V3S2",
                    "addressCountry": "CA"
                  }
                }
              }
            `}
          </script>
        </Helmet>

        <section
          className="hero-wrap hero-wrap-2"
          style={{ backgroundImage: "url('images/pricing_banner.jpg')" }}
          data-stellar-background-ratio="0.5"
        >
          <div className="overlay" />
          <div className="container">
            <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
              <AnimateOnScroll className="col-md-9 text-center">
                <h1 className="mb-3 bread">Pricing</h1>
                <p className="breadcrumbs">
                  <span className="mr-2">
                    <Link to="/">Home</Link>
                  </span>{' '}
                  <span>Pricing</span>
                </p>
              </AnimateOnScroll>
            </div>
          </div>
        </section>

        <AnimateOnScroll>
          <section className="ftco-section pricing-section">
            <div className="container">
              <div className="row justify-content-center mb-5 pb-3">
                <AnimateOnScroll className="col-md-7 heading-section text-center">
                  <h3 className="subheading">Pricing Tables</h3>
                  <h2 className="mb-1">Pricing Treatments</h2>
                </AnimateOnScroll>
              </div>

              {/* Render categories in rows of 3 */}
              {Object.entries(categories).length === 0 ? (
                <div className="text-center">No services available.</div>
              ) : (
              Object.entries(categories)
              .sort((a, b) => b[1].length - a[1].length) // Sort by number of services
              .reduce((rows, [categoryName, services], index) => {
                  if (index % 3 === 0) rows.push([]);
                  rows[rows.length - 1].push(renderCategoryBlock(categoryName, services, index));
                  return rows;
                }, []).map((row, i) => (
                  <div key={i} className="row grid-eq">{row}</div>
                ))
              )}
            </div>
          </section>
        </AnimateOnScroll>
      </div>
    </>
  );
}
